// src/components/Organizers/Organizers.jsx
import React from 'react';
import OrganizersTable from './OrganizersTable';

const Organizers = () => {
  return (
    <div className="organizers-page">
      <OrganizersTable />
    </div>
  );
};

export default Organizers;